import React, { useState, useEffect } from 'react';
import toJsonSchema from 'to-json-schema';
import ConverterLayout from './ConverterLayout';
import { Alert, Box, Typography } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';

function JsonSchemaGenerator() {
  const [json, setJson] = useState('{\n  "id": 1,\n  "name": "Item A",\n  "tags": ["new", "sale"]\n}');
  const [schema, setSchema] = useState('');
  const [error, setError] = useState('');

  const handleConvert = () => {
    setError('');
    if (!json.trim()) {
      setSchema('');
      return;
    }

    try {
      const doc = JSON.parse(json);
      const generatedSchema = toJsonSchema(doc);
      setSchema(JSON.stringify(generatedSchema, null, 2));
    } catch (e) {
      setError('Invalid JSON input. Please provide valid JSON.');
      setSchema('');
    }
  };

  const handleClear = () => {
    setJson('');
    setSchema('');
    setError('');
  };

  useEffect(() => {
    handleConvert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <SEO
        title="JSON Schema Generator | Infer Schema from JSON | UmbrellaCo"
        description="Automatically generate JSON Schema from any JSON object or data. Free online developer tool for inferring data structures."
        keywords="json schema generator, generate json schema online, json to json schema, infer json schema, json tools"
        url="/json-tools/schema-generator"
        jsonLd={createSoftwareAppSchema(
          'JSON Schema Generator',
          'Automatically generate JSON Schema definitions from JSON instances.',
          'https://umbrellaco.in/json-tools/schema-generator',
          ['JSON Schema Generation', 'Data Modeling', 'Developer Utilities']
        )}
      />
      {error && <Alert severity="error" sx={{ mx: 2, mb: 1 }}>{error}</Alert>}
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'hidden' }}>
        <ConverterLayout
          title="JSON Schema Generator"
          description="Paste a JSON object to automatically infer and generate its underlying JSON Schema representation."
          leftTitle="JSON Instance"
          rightTitle="Generated JSON Schema"
          leftLanguage="json"
          rightLanguage="json"
          leftValue={json}
          setLeftValue={setJson}
          rightValue={schema}
          onConvert={handleConvert}
          onClear={handleClear}
        />
      </Box>
    </Box>
  );
}

export default JsonSchemaGenerator;
